import { render, staticRenderFns } from "./ConfigureSkillLibrary.vue?vue&type=template&id=8d50c4aa&scoped=true&"
import script from "./ConfigureSkillLibrary.vue?vue&type=script&lang=js&"
export * from "./ConfigureSkillLibrary.vue?vue&type=script&lang=js&"
import style0 from "./ConfigureSkillLibrary.vue?vue&type=style&index=0&id=8d50c4aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d50c4aa",
  null
  
)

export default component.exports